import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {VenueServicesService} from "./venue-services.service";
import {VenueServices} from "./venue-services.data";
import {CustomerInstanceVenueData} from "../customer-instance-venue.data";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-services",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-services.component.html",
    styleUrls: ["./venue-services.component.scss"],
    providers: [VenueServicesService],
    standalone: false
})
export class VenueServicesComponent implements OnInit, OnDestroy {

    CustomerInstanceVenueData = CustomerInstanceVenueData;

    data: VenueServices;

    editing: boolean;

    subscription: Subscription = new Subscription();

    @Input() formGroupServices: FormGroup;

    @Input() allowStoreLimit: boolean;

    constructor(private errorHandler: ErrorHandlerService,
                public model: CustomerInstanceVenueModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscription.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            this.data = this.model.draft ? this.model.data.services : Object.assign({}, this.model.data.services);
            this.editing = this.model.draft || this.newEntity;
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    async save(): Promise<void> {
        if (this.formGroupServices.valid) {
            try {
                await this.model.saveServices(this.data);
                this.editing = false;
            } catch (e) {
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.data = Object.assign({}, this.model.data.services);
        this.editing = false;
    }

    get newEntity(): boolean {
        return !this.data.id;
    }
}
